import { render, staticRenderFns } from "./Prestaciones.vue?vue&type=template&id=1d174e58&"
import script from "./Prestaciones.vue?vue&type=script&lang=js&"
export * from "./Prestaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports